/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

require('./components/ripple.js')
require('./components/toggler.js')
require('./components/bootbox.js')
require('./components/alerts.js')
require('./components/add-required-label.js')
require('./components/messages.js')
require('./components/search-candidates.js')
require("./components/candidate-tile.js")
require("./components/menu-animation.js")



// WEBPACK FOOTER //
// ./resources/assets/js/app.js